<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}}</h3>
                </header>
            </section>
            <div class="divisor8"></div>
            <section class="widget">

                <div class="row">
                <div class="col-lg-12" style="padding: 0px">
                    <div class="row">
                        <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                            <inputCustom [titulo]="'Periodo evaluacion'"
                            [(ngModel)]="entidad.periodoevaluacion"
                            [disabled]="true"></inputCustom>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                            <inputCustom [titulo]="'Departamento'"
                            [(ngModel)]="entidad.departamento"
                            [disabled]="true"></inputCustom>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                            <div class="panelBotonesFiltro">
                                <button class="boton botonSM filledBlanco" (click)="modal()">
                                <span> {{'Enviar recordatorio a pendientes'}}</span>
                            </button>
                            </div>
                        </div>

                    </div>


                <!-- tabla -->
                <div *ngIf="accion.accionid == 1">
                 <!-- datos -->
                    <dx-data-grid
                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="listacolaborador"
                        [noDataText]="'Sin Datos'"
                        [showColumnHeaders]="true"
                        (onRowPrepared)="onRowPrepared($event)"
                        >
                        <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" matTooltip="Todo" ></dxo-export>

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="{{'Buscar' | translate}}">
                        </dxo-search-panel>

                        <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                        <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                            [displayMode]="sistemaService.tablaPaginacionModo"
                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                            [showInfo]="sistemaService.tablaPaginacionInfo"
                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                        </dxo-pager>

                        <dxi-column
                        dataField="nombreevaluador"
                        [groupIndex]="0"
                        groupCellTemplate="groupCellTemplateColaborador"
                        [autoExpandGroup]="true">
                    </dxi-column>

                        <dxi-column
                            dataField="nombre"
                            caption="Persona que evalúa">
                        </dxi-column>
                        <dxi-column
                            dataField="departamento"
                            caption="Departamento"
                            >
                        </dxi-column>
                        <dxi-column
                            dataField="puesto"
                            caption="Puesto">
                        </dxi-column>
                        <dxi-column
                            dataField="conteopregunta"
                            caption="Preguntas enviadas">
                        </dxi-column>
                        <dxi-column
                            dataField="cantidadrespuesta"
                            caption="Preguntas respondidas">
                        </dxi-column>
                        <dxi-column
                            dataField="cantidadfaltante"
                            caption="Preguntas pendientes">
                        </dxi-column>
                        <dxi-column
                        [allowExporting]="false"
                        caption="% de avance"
                        cellTemplate="cellavance"
                        alignment="center"
                        [minWidth]="120">
                    </dxi-column>
                        <div *dxTemplate="let cellInfocolaborador of 'groupCellTemplateColaborador'">
                            <div class="accionEncabezado">
                                <div class="accionEncabezado__titulo">
                                    {{cellInfocolaborador.value}}
                                </div>
                                <div class="accionEncabezado__acciones">
                                    <span>{{cellInfocolaborador.data.avance}}% ({{cellInfocolaborador.data.cantrespuesta}} de {{cellInfocolaborador.data.cantpregunta}} preguntas respondidas)</span>
                                </div>
                            </div>
                        </div>
                        <div *dxTemplate="let cell of 'cellavance'">
                            <span>{{cell.data.avance}}%</span>
                        </div>
                    </dx-data-grid>

                </div>

                <!-- tabla -->
                <div *ngIf="accion.accionid != 1">
                 <!-- datos -->
                    <dx-data-grid
                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="listaalumno"
                        [noDataText]="'Sin Datos'"
                        [showColumnHeaders]="true"
                        (onRowPrepared)="onRowPrepared($event)"
                        >
                        <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" matTooltip="Todo" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="{{'Buscar' | translate}}">
                        </dxo-search-panel>

                        <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                        <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                            [displayMode]="sistemaService.tablaPaginacionModo"
                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                            [showInfo]="sistemaService.tablaPaginacionInfo"
                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                        </dxo-pager>
                        <dxi-column
                            dataField="nombrecol"
                            caption="Persona a evaluar">
                        </dxi-column>
                        <dxi-column
                            dataField="nivel"
                            caption="Nivel">
                        </dxi-column>
                        <dxi-column
                            dataField="grado"
                            caption="Grado">
                        </dxi-column>
                        <dxi-column
                            dataField="grupo"
                            caption="Grupo">
                        </dxi-column>
                        <dxi-column
                            dataField="materia"
                            caption="Materia o taller">
                        </dxi-column>
                        <dxi-column
                            dataField="puesto"
                            caption="Puesto">
                        </dxi-column>
                        <dxi-column
                        [allowExporting]="false"
                        caption="% de avance"
                        cellTemplate="cellavance"
                        alignment="center"
                        [minWidth]="120">
                    </dxi-column>
                    <div *dxTemplate="let cell of 'cellavance'">
                        <span>{{cell.data.avance}}%</span>
                    </div>
                    </dx-data-grid>

                </div>

                </div>
                </div>
                <div class="divisor20"></div>
                <div class="row margen" >
                    <div class="col-12">
                        <div class="panelBotonesFiltro">
                            <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                            (click)="Salir()">
                            <span> {{'Cerrar'}}</span>
                        </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>


<ng-container *ngIf="abierto">
    <div class="backdrop"></div>
    <div class="modalPanelAdmin animated {{animacion}}">

        <div class="contenido">
            <div class="encabezadoModal">
                <div class="modalTituloSimple">
                    {{('Asignar porcentaje minimo')}}
                </div>
            </div>
            <div class="modalContenido">
              <div>
                <div class="divisor8"></div>
                  <div class="row">
                    <div class="col-6">
                      <inputCustom [titulo]="'Porcentaje minimo'"
                      [(ngModel)]="porcentaje" [mask]="sistemaService.numeroEnteroMask"></inputCustom>
                    </div>
                  </div>
              </div>
            </div>

            <div class="modalFooter">
                <div class="contenidoFooter botonesIzq">
                    <div class="botonDerecha">
                        <button class="boton botonSM filledBlanco" (click)="cerrarModal()">
                            {{'Cancelar' | translate}}
                        </button>
                        <div class="divisorH16"></div>
                        <button class="boton botonSM filled" (click)="mandarEmail(porcentaje)">
                            {{'Enviar recordatorio' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
